import React from 'react';
import { Sparkles, MessageSquare, ArrowRight } from 'lucide-react';
import Button from './ui/Button';

const LumoPromo = () => {
  return (
    <div className="rounded-2xl border border-border bg-muted/30 p-6 sm:p-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 text-primary mb-2">
            <Sparkles className="w-5 h-5" />
            <span className="text-sm font-medium">Meet Lumo</span>
          </div>
          <h3 className="text-2xl font-bold mb-2">Your AI Sales Mentor</h3>
          <p className="text-muted-foreground">
            Practice objections, refine scripts, and get instant coaching feedback powered by the Lumo method.
            No setup required—jump into guided scenarios and improve faster with clear, actionable insights.
          </p>
          <ul className="mt-4 grid sm:grid-cols-2 gap-2 text-sm text-muted-foreground">
            <li className="flex items-center gap-2"><span className="inline-block w-2 h-2 rounded-full bg-success" /> Guided practice scenarios</li>
            <li className="flex items-center gap-2"><span className="inline-block w-2 h-2 rounded-full bg-success" /> Strengths & improvements</li>
            <li className="flex items-center gap-2"><span className="inline-block w-2 h-2 rounded-full bg-success" /> Sample responses</li>
            <li className="flex items-center gap-2"><span className="inline-block w-2 h-2 rounded-full bg-success" /> Progress tracking</li>
          </ul>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Button size="sm" onClick={() => window.location.href = '/app/meet-lumo'}>
            Try Lumo Now
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
          <Button variant="ghost" size="sm" onClick={() => window.location.href = '/app/mega-trainer'}>
            Explore Training
            <MessageSquare className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LumoPromo;
